<template>
  <div class="szkf-wrap">
    <div class="szkf-top">
      <div class="szkf-top-left" v-if="false"></div>
      <div class="szkf-top-right">
        <div v-if="doadd" :class="[{ titleChecked: titleIndex == 0 }]" @click="operation(0)">创建</div>
        <div v-if="doupdate" :class="[{ titleChecked: titleIndex == 1 }]" @click="operation(1)">修改</div>
        <div v-if="dodelete" :class="[{ titleChecked: titleIndex == 2 }]" @click="operation(2)">删除</div>
      </div>
    </div>

    <div class="szkf-container">
      <img src="../assets/image/lq-bg.png" alt />
      <div>
        <div class="yx-wrap">
          <div class="yx-title">
            <div style="flex:1">序号</div>
            <!-- <div>中央会员类型</div> -->
            <div>中央会员房型</div>
            <div>本地房型名称</div>
            
          </div>
          <div class="yx-contaniner">
            <transition-group name="list" tag="p">
              <div
                :class="['yx-item', { ckcheck: ckIndex == index }]"
                v-for="(item, index) in list"
                :key="item.id"
                @click="chooseIndex(index)"
                @dblclick="dblItem(index)"
              >
                <div style="flex:1">{{ index + 1 }}</div>
                <!-- <div>{{ item.membertypename }}</div> -->
                <div>{{ item.grouproomtypename }}</div>
                <div>{{ item.roomtypename }}</div>
      
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// vue是对数据的编程，所以做啥都跟数据有关
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      doadd: false,
      doupdate: false,
      dodelete: false
    };
  },
  computed: {
    titleIndex() {
      return this.$store.state.operationIndex; //点击事件：点击发生了什么——>按钮用这个统一样式
    },
    ckIndex() {
      return this.$store.state.tMemberRoomTypeIndex; //一行数据点击之后用这个统一样式
    },
    list(){
      return this.$store.state.tMemberRoomTypeList
    }
  },
  created() {
    this.checkPower(); //验证权限，有没有权限做这些事，如果有就继续，方法里面有权限的获取

    let loadingInstance = this.$loading({ text: "加载中" }); //如果这数据不存在，则要去接口请求数据
    getRequest("tMemberRoomType/selectAll").then(res => {
      this.$nextTick(() => {
        loadingInstance.close();
      }); //不回调
      if (res.status == 200) {
     
        this.$store.state.tMemberRoomTypeList = res.data

      } else {
        this.$mymessage({
          content: res.message,
          type: "error",
          time: 3000,
          hasClose: true
        }); //如果无法获取这一条数据，就报错
      }
    });
  },
  methods: {
    checkPower() {
      //获取权限码
      if (!this.power.checkedpower("0807001")) {
        //在PMS管理系统里面-获取权限
        this.$router.push("/power");
      }
      this.doadd = this.power.checkedpower("0807002");
      this.doupdate = this.power.checkedpower("0807003");
      this.dodelete = this.power.checkedpower("0807004");
    },
    operation(index) {
      if (index == 0) {
        //index為0，就是創建，前面有寫
        this.$store.state.operationIndex = index; //要在store裡面定义变量
        this.showbox({ operation: "创建" }); //窗口的定义，后面引用operation为创建
      } else if (index == 1) {
        //index为1，就是修改
        if (this.ckIndex != null) {
          //修改需要判断，是否选中要修改的数据，如果有就继续
          let obj = JSON.parse(
            JSON.stringify(this.list[this.ckIndex])
          ); //如果选中了要修改的数据，那么就要先提取出来，以便后面操作修改
          obj.operation = "修改";
          obj.index = this.ckIndex; //这个点击选中的一行要修改的数据，赋值给在store里面定义的对象
          this.$store.state.operationIndex = index;
          this.showbox(obj);
        } else {
          this.$mymessage({
            content: "请选择修改内容",
            type: "error",
            time: 2000,
            hasClose: true
          });
          return;
        }
      } else if (index == 2) {
        if (this.ckIndex != null) {
          let obj = JSON.parse(
            JSON.stringify(this.$store.state.tMemberRoomTypeList[this.ckIndex])
          );
          obj.title = "删除";
          obj.message = "您确定要删除吗";
          obj.tMemberRoomTypeIndex = this.ckIndex;
          obj.tMemberRoomType = true
          this.$store.state.operationIndex = index;
          this.$confirm({ obj });
        } else {
          this.$mymessage({
            content: "请选择删除内容",
            type: "error",
            time: 2000,
            hasClose: true
          });
        }
      }
    },
    showbox(obj) {
  
      this.$fangxingduiying({ obj });
    },
    chooseIndex(index) {
      this.$store.state.tMemberRoomTypeIndex = index;
    },
    dblItem(index) {
      this.$store.state.tMemberRoomTypeIndex = index;
      this.operation(1);
    }
  }
};
</script>

<style scoped>
.yx-wrap {
  width: 100%;
  height: 100%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.yx-title {
  width: 50%;
  display: flex;
  flex-shrink: 0;
}
.yx-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  flex:3
}
.yx-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: auto;
}
.yx-contaniner .ckcheck {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}

.yx-item {
  display: flex;
  width: 50%;
  border: 1px solid #e7f0ff;
  cursor: pointer;
}
.yx-item div {
  text-align: center;
  line-height: 3em;
 flex:3;
 overflow: hidden;
}


.yx-checked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.szkf-wrap {
  width: 100%;
  height: 100%;
  z-index: 99;
  position: relative;
  overflow: hidden;
}
.szkf-top {
  width: 101%;
  height: 7%;
  padding: 0 3%;
  /* background: red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2%;
  position: relative;
}
.szkf-top-left {
  width: 50%;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
  /* background: red; */
}
.szkf-top-left div {
  /* width: 13%; */
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 0 3%;
  cursor: pointer;
  position: absolute;
  right: 3%;
}
.szkf-top-right div {
  width: 30%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.szkfchecked,
.titleChecked {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.szkf-top-right {
  width: 20%;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
  position: absolute;
  right: 3%;
}
.szkf-top-right > div {
  cursor: pointer;
}
.szkf-container {
  width: 101.8%;
  height: 93%;
  margin: 0 0 0;
  position: absolute;
  top: 8.5%;
  left: -1%;
}
.szkf-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.szkf-container > div {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 2% 3%;
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}
.fade-enter {
  transform: translateX(100%);
  opacity: 0;
}
.fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
</style>